@if (project$ | async; as project) { @if (facilityId$ | async; as facilityId) {
<a class="project-link" [routerLink]="['/project', project.id, 'facility', facilityId]">
  <button class="iconf-btn-blank minw50">
    <mat-icon class="arrow lightblue">chevron_left</mat-icon>
  </button>
</a>
}
<div>
  @if (project) {
  <span class="project lightblue">{{ project.businessUnit + ' Project: ' + project.name }}</span>
  <span class="project grey"> > System selection</span>
  }
  <div class="title">systems selection</div>
</div>
<app-user-button class="usr-btn"></app-user-button>
}
